import './App.css';
import { useState, useEffect, useRef } from 'react';

import {Keyboard} from './components/keyboard/Keyboard';

function App() {
  const [money, setMoney] = useState(0);
  const [isCooledDown, setIsCooledDown] = useState(true);
  const [isRainingMoney, setIsRainingMoney] = useState(false);

  const cookies = document.cookie.split("; ").reduce((prev, curr, indx, fullArr) => {
    if (!prev) return {};

    const [name, val] = curr.split("=");
    prev[name] = val;
    return prev;
  }, {});
  console.log(cookies);

  useEffect(() => {
    if (cookies["money"]) {
      setMoney(parseInt(cookies["money"]));
  }
  }, []);

  function saveMoneyCookie() {
    document.cookie = `money=${money}`;
  }

  function MoneyRain() {
    const totalElements = 35;
    return Array.apply(null, Array(totalElements)).map(() => (
      <div
        className={`${isRainingMoney ? 'money money-rain-animation' : ''}`}
        style={
          {
            top: `${Math.floor(Math.random() * 251)}px`,
            left: `${25 + Math.floor(Math.random() * 51)}%`
          }
        }
      />
    ));
  }

  const audioRef = useRef(new Audio("coin.mp3"));

  function playSound() {
    audioRef.current.currentTime = 0;
    audioRef.current.play();
  }

  function workClicked() {
    if (!isCooledDown) {
      return;
    }
    const newMoney = money + 1;
    if (newMoney % 10 == 0) {
      triggerMoneyRain();
      saveMoneyCookie();
    }
    setMoney(newMoney);
    playSound();
    setIsCooledDown(false);
    setTimeout(() => {
      setIsCooledDown(true);
    }, 300);
  }

  function triggerMoneyRain() {
    setIsRainingMoney(true);
    setTimeout(() => {
      setIsRainingMoney(false);
    }, 1000);
  }

  return (
    <div className="App">
      <header className="App-header">
        <p>Money: {money}</p>
        <input type="button" onClick={workClicked} value="Trabajar" />
        <Keyboard />
        {MoneyRain()}
        <iframe width="560" height="315" src="https://www.youtube.com/embed/K5eC9E8Npoo?autoplay=1&loop=1" title="Trillonarios VIP" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <h3>
          El método infalible para ganar trillones
        </h3>
        <p>
          Te enseñamos nuestro método de neuroabundancia para que despliegues tu potencial trillonario
        </p>
        <ul>
          <li>
            Próximamente...
          </li>
        </ul>
      </header>
    </div>
  );
}

export default App;
